import { Banner, Button, FlexBox, Spinner, Text } from '@dixa/lib-shared-habla';

import styles from '../composeEmailModal.module.scss';
import type { FormValues } from '../composeEmailModal.types';

const linkTypeLabelMap = (
  parentConversation: number,
): Record<string, string> => ({
  email_forward: `Compose a transcript of conversation #${parentConversation}`,
  follow_up: `Follow-up on conversation #${parentConversation}`,
  side: `Compose a side conversation to #${parentConversation}`,
});

type ComposeEmailLinkedBannerProps = {
  linkType: FormValues['linkType'];
  parentConversation: number;
  linkedDataLoading: boolean;
  onCopyPaste: () => void;
};

function getActionSlot({
  linkType,
  linkedDataLoading,
  onCopyPaste,
}: Omit<ComposeEmailLinkedBannerProps, 'parentConversation'>):
  | JSX.Element
  | undefined {
  if (linkedDataLoading) {
    return (
      <FlexBox alignItems="center" gap="200">
        <Spinner size={20} />
        <Text.Paragraph variant="1">Generating transcript…</Text.Paragraph>
      </FlexBox>
    );
  }

  if (!linkType || linkType === 'side') {
    return (
      <Button type="button" variant="secondary" onClick={onCopyPaste}>
        Insert transcript
      </Button>
    );
  }

  return undefined;
}

export function ComposeEmailLinkedBanner({
  linkType,
  parentConversation,
  linkedDataLoading,
  onCopyPaste,
}: ComposeEmailLinkedBannerProps): JSX.Element {
  return (
    <Banner
      className={styles.banner}
      variant="info"
      icon={null}
      description={
        <Text.Paragraph variant="1">
          {linkTypeLabelMap(parentConversation)[linkType ?? 'side']}
        </Text.Paragraph>
      }
      actionSlot={getActionSlot({ linkType, linkedDataLoading, onCopyPaste })}
    />
  );
}
